import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

import {getTranslation} from 'shared/helpers/get-translation';

import { NavService } from 'shared/nav/nav.service';
import {Dialog, DialogGroups} from '../../model/model';
import { UserService } from 'app/profile';
import { DefaultPage } from 'app/menu/components/default-page/default-page';

const INDEX_FORMAT: string = 'MM-DD-YYYY';
const LABEL_FORMAT: string = 'dddd, DD.MM.';

@Component({
  selector: 'dialogs-list-page',
  templateUrl: 'dialogs-list-page.html',
  styleUrls: ['dialogs-list-page.scss'],
})
export class DialogsListPage extends DefaultPage {

  private _dialogGroups: DialogGroups;

  public isShowTime: boolean = false;

  constructor(
    public navService: NavService,
    public translateService: TranslateService,
    private userService: UserService,
  ) {
    super(navService);
    this._dialogGroups = this.navService.get('dialogs') as DialogGroups;
    // this._dialogs.forEach(d => console.log(d));
    if ( userService.getAdminMode() ) {
      this.isShowTime = true;
    }
  }

  public get dialogGroupsByDay(): DialogGroups {
    return this._dialogGroups;
  }

  public get groupDates(): Array<string> {
    return Object.keys(this.dialogGroupsByDay).sort((a, b) => {
      return moment(b, INDEX_FORMAT).diff(moment(a, INDEX_FORMAT));
    });
  }

  public getDialogTitle(dialog: Dialog): string {
    if (dialog) {
      if (dialog.fullGoal !== undefined && dialog.fullGoal.dialog === undefined) {
        return dialog.fullGoal.title;
      }
      return getTranslation(dialog.title, this.translateService);
    }

    return '';
  }

  public getDateLabel(date: string): string {
    return moment(date, INDEX_FORMAT).format(LABEL_FORMAT);
  }

  public onItemClicked(item: Dialog): void {
    if (item.contentInfo !== undefined) {
      this.navService.push('content/flow', { dialog: item });
    }
    else {
      this.navService.push('dialogs/detail', { dialog: item });
    }
  }
}
